import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Header from './Header.component';

const mapStateToProps = state => ({
  errors: state.errors,
});

export default connect(mapStateToProps)(withRouter(Header));
